export const USER_ROLES = {
  PRINCIPAL_ROLE: "principal",
  COUNSELLOR_ROLE: "counsellor",
  STUDENT_ROLE: "student",
  ADMIN_ROLE: "admin",
  ALLBRY_COUNSELLOR_ROLE: "allbryCounsellor",
};

export const CUSTOM_USER_ROLES = {
  [USER_ROLES.PRINCIPAL_ROLE]: {
    USER_MANAGEMENT: "userManagement",
    DASHBOARD: "dashboard",
    ORGANIZATION_SETTINGS: "organizationSettings",
    SURVEY_CONFIG: "surveyConfig",
    CUSTOM_REPORTS: "customReports",
    PROCESS: "process",
    ROLE_MANAGEMENT: "roleManagement",
  },
  [USER_ROLES.COUNSELLOR_ROLE]: {
    APPOINTMENTS: "appointments",
    DASHBOARD: "dashboard",
    STUDENT_PROFILE: "studentProfile",
    CHATS: "chats",
    STUDENT_LIST: "studentList",
    NOTES: "notes",
    REPORTS: "reports",
    VIDEO: "video",
    INTERNAL_REPORT: "internalReport",
    ANONYMOUS_QUICK_REPORT: "anonymousQuickReport",
    CUSTOM_REPORTS: "customReports",
    PROCESS: "process",
    SURVEY_CONFIG: "surveyConfig",
    STATISTICS: "statistics",
    CONTACT_CARD_VIEW: "contactCardView",
    CONTACT_CARD_MANAGE: "contactCardManage",
    GROWTH_MEASUREMENT_VIEW: "growthMeasurementView",
    GROWTH_MEASUREMENT_MANAGE: "growthMeasurementManage",
    VISION_SCREENING_VIEW: "visionScreeningView",
    VISION_SCREENING_MANAGE: "visionScreeningManage",
    STUDENT_MARKER_VIEW: "studentMarkerView",
    STUDENT_MARKER_MANAGE: "studentMarkerManage",
    HEARING_SCREENING_VIEW: "hearingScreeningView",
    HEARING_SCREENING_MANAGE: "hearingScreeningManage",
    REFERRAL_VIEW: "referralView",
    REFERRAL_MANAGE: "referralManage",
    CONSENT_VIEW: "consentView",
    CONSENT_MANAGE: "consentManage",
    USER_MANAGEMENT: "userManagement",
  },
  [USER_ROLES.STUDENT_ROLE]: {
    APPOINTMENTS: "appointments",
    CHATS: "chats",
    COUNSELLOR_PROFILE: "counsellorProfile",
    VIDEO: "video",
    SURVEY_AND_CHECK_IN_PAGE: "surveyAndCheckInPage",
  },
};

export const SURVEY_STATUSES = {
  STUDENT_SURVEY: "studentSurvey",
  STUDENT_GENDER: "studentGender",
};

export const PROCESS_CATEGORIES = {
  INVESTIGATION: {
    nameSw: "Utredning",
    nameEng: "Investigation",
    description: "Tex ADHD-utredning",
    value: "INVESTIGATION",
  },
  CASE: {
    nameSw: "Ärende",
    nameEng: "Case",
    description: "Här ligger sett ärende en gång",
    value: "CASE",
  },
  PROGRAM: {
    nameSw: "Program",
    nameEng: "Program",
    description: "Utvecklingsprogram",
    value: "PROGRAM",
  },
};

export const GLOBAL_JOURNALS = {
  GENERAL_RECORD_ID: "f5b4059f-bf6e-4829-8e7d-04ab1b2d031b",
};

export const AFTER_SURVEY_STEPS = {
  FIRST_STEP: "appointments",
  SECOND_STEP: "messages",
};

export const CHAT_MESSAGE_TYPES = {
  TEXT: "text",
  ATTACHMENT: "attachment",
  TEXT_ATTACHMENT: "textAttachment",
  AKK_IMAGE: "image",
  END: "end",
  ARCHIVED: "archived",
  VIDEO_CALL: "videoCall",
  START_CHAT: "startChat",
};

export const millisecondsInHour = 3600000;

export const NOTE_TYPES = {
  MANUAL: "manual",
  APPOINTMENT: "appointment",
  META: "meta",
};

export const GENDERS = {
  MALE: "Male",
  FEMALE: "Female",
  OTHER: "Other",
};

export const USER_STATUSES = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  DEACTIVATED: "deactivated",
};

export const USER_STATUS = {
  TRUE: true,
  FALSE: false,
};

export const SURVEY_TIMER = {
  DAILY: "Daily",
  WEEKLY: "Weekly",
  MONTHLY: "Monthly",
};

export const ORGANIZATION_STATUSES = {
  ACTIVE: "active",
  DEACTIVATED: "deactivated",
};

export const FREE_TIME_REPEAT_TYPES = {
  NONE: "none",
  EVERYDAY: "everyday",
  WEEKLY: "weekly",
  EVERY_WEEKDAY: "every_weekday",
};

export const MEDIA_FONT_SIZE = {
  XS: 12,
  SM: 14,
  BASE: 16,
};

export const MEDIA_SCREEN = {
  MOBILE: 768,
  SM: 1280,
  LG: 1601,
};

export const NOTIFICATION_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  UPCOMING: "Upcoming",
  SENT: "Sent",
};

export const SURVEY_TEMPLATE_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};

export const SURVEY_CONFIG_RUN_ONCE = {
  ACTIVE: "true",
  INACTIVE: "false",
};

export const SURVEY_STATISTICS_STATUS = {
  ACTIVE: "active",
  NEW: "new",
  COMPLETE: "complete",
};

export const SURVEY_QUESTION_TYPES = {
  FILLING: "filling",
  SINGLE_SELECT: "single-select",
  RANGE_SLIDER: "rang-slider",
  RANKING: "ranking",
  CHECKBOX: "checkbox",
  TAG_BOX: "tagbox",
  BOOLEAN: "boolean",
  RATING: "rating",
  RADIO_GROUP: "radiogroup",
  DROPDOWN: "dropdown",
  IMAGE: "images",
  TEXT: "text",
  COMMENT: "comment",
  FILE: "file",
};

export const REMINDER_STATUSES = {
  TODO: "TODO",
};

export const ENTITY_TABLES = {
  CUSTOM_REPORT_TAGGED_USERS: "customReportTaggedUsers",
};

export const BG_COLOR_COUNSELLING_POPULAR_CHART = [
  "#E9967A",
  "#B8860B",
  "#8FBC8F",
  "#FF7F50",
  "#BDB76B",
  "#556B2F",
  "#FFA07A",
  "#9ACD32",
  "#DAA520",
  "#FA8072",
  "#CD5C5C",
  "#EEE8AA",
  "#F0E68C",
  "#F0E68C",
  "#808000",
  "#CF7602",
  "#474645",
  "#8B4513",
  "#8B4513",
  "#808000",
  "#CF7602",
  "#E9967A",
  "#B8860B",
  "#8FBC8F",
  "#FF7F50",
  "#BDB76B",
  "#556B2F",
  "#FFA07A",
  "#9ACD32",
  "#DAA520",
  "#FA8072",
  "#CD5C5C",
  "#EEE8AA",
  "#2F4F4F",
  "#800000",
  "#FFDAB9", // Peach Puff
  "#FFE4B5", // Moccasin
  "#FFFACD", // Lemon Chiffon
  "#E0FFFF", // Light Cyan
  "#F5FFFA", // Mint Cream
  "#F0FFF0", // Honeydew
  "#F5F5DC", // Beige
  "#FFF0F5", // Lavender Blush
  "#E6E6FA", // Lavender
  "#F8F8FF", // Ghost White
  "#F0F8FF", // Alice Blue
  "#FAFAD2", // Light Goldenrod Yellow
  "#FFEFD5", // Papaya Whip
  "#FFF5EE", // Seashell
  "#F5DEB3", // Wheat
  "#FDF5E6", // Old Lace
  "#FFFAF0", // Floral White
  "#F0FFFF", // Azure
  "#F4A460", // Sandy Brown (light)
  "#FFD700", // Gold (light)
  // Added slightly darker (but not too dark) colors
  "#D2B48C", // Tan
  "#C0C0C0", // Silver
  "#B0C4DE", // Light Steel Blue
  "#A9A9A9", // Dark Gray
  "#BC8F8F", // Rosy Brown
  "#BDB76B", // Dark Khaki
  "#CD853F", // Peru
  "#CDAA7D", // Antique Brass
  "#A0522D", // Sienna (not too dark)
];

export const BROADCAST_MESSAGES_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};

export const REPORT_TOPICS_CATEGORY_TYPE = {
  STUDENT: "STUDENT",
  COUNSELLOR: "COUNSELLOR",
};

export const STUDENT_COLORS_FLAG = [
  {
    color: "3green",
    value: "#97d3b9",
  },
  {
    color: "2yellow",
    value: "#fdce96",
  },
  {
    color: "1red",
    value: "#f7a6a4",
  },
];

// For broadcast chat modules super admin.
export const SUPER_ADMIN_SENDER_NAME = "Allbry";

export const REPORT_TOPIC_TYPES = {
  QUICK: "QUICK",
};

export const REPORT_TYPES = {
  APPOINTMENT: "appointment",
  APPOINTMENT_QUICK: "appointment_quick",
  CHAT: "chat",
  CHAT_QUICK: "chat_quick",
  INSTANT: "instant",
  QUICK: "quick",
  ANONYMOUS_QUICK_REPORT: "anonymous_quick_report",
  ANONYMOUS_ULTRA_QUICK_REPORT: "anonymous_ultra_quick_report",
  INTERNAL_REPORT: "internal",
  NOTES: "notes",
  CUSTOM_REPORTS: "customReports",
  NOTES_TYPES: "Note",
  META: "meta",
  APPOINTMENT: "appointment",
  MANUAL: "manual",
};

export const REPORT_SCREEN_TYPES = {
  MODAL: "MODAL",
  FULL_PAGE: "FULL_PAGE",
};

export const REMINDER_BOARD_STATUS_COLUMN = {
  TODO: "TODO",
  DOING: "DOING",
  DONE: "DONE",
  ARCHIVE: "ARCHIVE",
};

export const REPORT_TEMPLATE_ACCESS_TYPES = {
  GLOBAL: "GLOBAL",
  LOCAL: "LOCAL",
};

export const SURVEY_AND_CHECK_IN_TEMPLATE_ACCESS_TYPES = {
  GLOBAL: "global",
  LOCAL: "local",
};

export const SUBSCRIPTION_TYPES_CODE = {
  FREE: "FREE",
  CONSUMER: "CONSUMER",
  CHOOSE_ATTRIBUTES: "CHOOSE_ATTRIBUTES",
};

export const CUSTOM_REPORT_STATUSES = {
  UPDATED: "updated",
  UPDATED_DRAFT: "updated_draft",
  REMOVED: "removed",
  SIGNED: "signed",
  UNLOCKED: "unlocked",
  VIEWED: "viewed",
  EXPORTED: "exported",
};

export const CUSTOM_REPORT_SIGNATURE_STATUSES = {
  DRAFT: "draft",
  SIGNED: "signed",
};

export const PROCESS_CONFIG_STATUS = {
  ACTIVE: "active",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
};

export const PROCESS_TASK_TYPES = {
  MANUAL: "MANUAL",
  APPOINTMENT: "APPOINTMENT",
  CUSTOM_REPORT: "CUSTOM_REPORT",
  NOTE: "NOTE",
  REMINDER: "REMINDER",
  SURVEY: "SURVEY",
  CONSENT: "CONSENT",
  INFORMATION: "INFORMATION",
  VISION_SCREENING: "VISION_SCREENING",
  HEARING_SCREENING: "HEARING_SCREENING",
  GROWTH_MEASUREMENT: "GROWTH_MEASUREMENT",
  REFERRAL: "REFERRAL",
};

export const PROCESS_TASK_STATUS = {
  TODO: "todo",
  DONE: "done",
  CANCELLED: "cancelled",
  SKIPPED: "skipped",
};

export const PROCESS_COMPLETION_METHOD = {
  MANUAL: "manual",
  SYSTEM: "system",
};

export const GROWTH_MEASUREMENT_TYPES = {
  ROUTINE: "routine",
  FOLLOW_UP: "follow_up",
  EXTRA_CHECK: "extra_check",
  IMPORTED: "imported",
};

export const GROWTH_MEASUREMENT_SIGNATURE_STATUSES = {
  DRAFT: "draft",
  SIGNED: "signed",
};

export const GROWTH_MEASUREMENT_ARCHIVE_STATUSES = {
  CREATED: "created",
  UPDATED_DRAFT: "updated_draft",
  SIGNED: "signed",
  UNLOCKED: "unlocked",
  EXPORTED: "exported",
  REMOVED: "removed",
};

export const REFERRAL_ARCHIVE_EVENT_TYPES = {
  CREATED: "created",
  UPDATED_DRAFT: "updated_draft",
  SIGNED: "signed",
  UNLOCKED: "unlocked",
  MARKED_SENT: "marked_sent",
  RESPONSE_UPLOADED: "response_uploaded",
  RESPONSE_REGISTERED: "response_registered",
  CLOSED: "closed",
  CANCELLED: "cancelled",
  DELETED: "deleted",
  EXPORTED: "exported",
};

export const TANNER_STAGES = ["I", "II", "III", "IV", "V"];

export const MENARCHE_STATUSES = {
  NOT_ASSESSED: "not_assessed",
  NO: "no",
  YES: "yes",
  UNKNOWN: "unknown",
};

export const VISION_SCREENING_SIGNATURE_STATUSES = {
  DRAFT: "draft",
  SIGNED: "signed",
};

export const VISION_SCREENING_ARCHIVE_STATUSES = {
  CREATED: "created",
  UPDATED_DRAFT: "updated_draft",
  SIGNED: "signed",
  UNLOCKED: "unlocked",
  EXPORTED: "exported",
  REMOVED: "removed",
  FINAL_ASSESSMENT_UPDATED: "final_assessment_updated",
};

export const VISION_SCREENING_TYPES = {
  ROUTINE: "routine",
  FOLLOW_UP: "follow_up",
  EXTRA_CHECK: "extra_check",
  IMPORTED: "imported",
};

export const VISION_SCREENING_CONTACT_TYPES = {
  HEALTH_VISIT: "health_visit",
  RECEPTION_VISIT: "reception_visit",
  FOLLOW_UP: "follow_up",
  OTHER: "other",
};

export const VISION_SCREENING_CORRECTION_STATUSES = {
  NONE: "none",
  GLASSES: "glasses",
  CONTACT_LENSES: "contact_lenses",
  UNKNOWN: "unknown",
  NOT_TESTED: "not_tested",
};

export const VISION_SCREENING_TEST_METHODS = {
  KM_CHART: "km_chart",
  HVOT_CHART: "hvot_chart",
  EVND_CHART: "evnd_chart",
  SNELLEN_ROWS: "snellen_rows",
  LETTER_ROWS: "letter_rows",
  LEA_SYMBOLS: "lea_symbols",
  OTHER: "other",
};

export const VISION_SCREENING_RESULT_STATUSES = {
  NORMAL: "normal",
  INCOMPLETE: "incomplete",
  NEEDS_RETEST: "needs_retest",
  FOLLOW_UP_NEEDED: "follow_up_needed",
  REFER_OPTICIAN: "refer_optician",
  REFER_EYE_CLINIC: "refer_eye_clinic",
};

export const VISION_SCREENING_FINAL_ASSESSMENTS = {
  NORMAL: "normal",
  RETEST: "retest",
  FOLLOW_UP_NEEDED: "follow_up_needed",
  REFER_OPTICIAN: "refer_optician",
  REFER_EYE_CLINIC: "refer_eye_clinic",
  PRIMARY_CARE: "primary_care",
  NO_ACTION: "no_action",
};

export const VISION_ACUITY_VALUES = [
  null,
  0.1,
  0.2,
  0.3,
  0.4,
  0.5,
  0.6,
  0.7,
  0.8,
  0.9,
  1.0,
  1.2,
  1.5,
  2.0,
  2.5,
  3.0,
];

export const VISION_SCREENING_REFERRAL_TARGETS = {
  EYE_CLINIC: "eye_clinic",
  OPTICIAN: "optician",
};

export const VISION_SCREENING_DEFAULT_SETTINGS = {
  visionAcuityPassThreshold: 0.8,
  maxInterocularDifference: 0.2,
  requireBothEyesTested: true,
  referUnderAgeYearsTo: VISION_SCREENING_REFERRAL_TARGETS.EYE_CLINIC,
  referFromAgeYearsTo: VISION_SCREENING_REFERRAL_TARGETS.OPTICIAN,
  opticianReferralAgeYears: 8,
};

export const STUDENT_MARKER_TYPES = {
  ALLERGY: "allergy",
  HYPERSENSITIVITY: "hypersensitivity",
  MEDICAL_WARNING: "medical_warning",
  INFORMATION: "information",
};

export const STUDENT_MARKER_SEVERITIES = {
  LOW: "low",
  HIGH: "high",
};

export const STUDENT_MARKER_SOURCE_TYPES = {
  MANUAL: "manual",
  IMPORTED: "imported",
  OTHER: "other",
};

export const STUDENT_MARKER_STATUSES = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};

export const HEARING_SCREENING_SIGNATURE_STATUSES = {
  DRAFT: "draft",
  SIGNED: "signed",
};

export const HEARING_SCREENING_ARCHIVE_STATUSES = {
  CREATED: "created",
  UPDATED_DRAFT: "updated_draft",
  SIGNED: "signed",
  UNLOCKED: "unlocked",
  EXPORTED: "exported",
  REMOVED: "removed",
  FINAL_ASSESSMENT_UPDATED: "final_assessment_updated",
};

export const HEARING_SCREENING_TYPES = {
  ROUTINE: "routine",
  FOLLOW_UP: "follow_up",
  EXTRA_CHECK: "extra_check",
  IMPORTED: "imported",
};

export const HEARING_SCREENING_CONTACT_TYPES = {
  HEALTH_VISIT: "health_visit",
  RECEPTION_VISIT: "reception_visit",
  FOLLOW_UP: "follow_up",
  OTHER: "other",
};

// All frequencies the form can capture. Only the subset in
// HEARING_SCREENING_DEFAULT_SETTINGS.requiredFrequencies must be filled
// before a screening counts as complete.
export const HEARING_FREQUENCIES = [
  250, 500, 1000, 2000, 3000, 4000, 6000, 8000,
];

export const HEARING_SCREENING_RESULT_STATUSES = {
  NORMAL: "normal",
  INCOMPLETE: "incomplete",
  MINOR_DEVIATION: "minor_deviation",
  NEEDS_RETEST: "needs_retest",
  FOLLOW_UP_NEEDED: "follow_up_needed",
  REFERRED: "referred",
};

export const HEARING_SCREENING_FINAL_ASSESSMENTS = {
  NORMAL: "normal",
  NEEDS_RETEST: "needs_retest",
  FOLLOW_UP_NEEDED: "follow_up_needed",
  REFERRED: "referred",
  NO_ACTION: "no_action",
};

// Hardcoded for MVP, mirroring the backend's HEARING_SCREENING_DEFAULT_SETTINGS
// (allbry-be-nestjs hearing-screening.constants.ts) — kept in sync manually,
// same convention as VISION_SCREENING_DEFAULT_SETTINGS above. There is no
// per-account settings UI to override these yet (out of scope for this module).
export const HEARING_SCREENING_DEFAULT_SETTINGS = {
  screeningThresholdDb: 20,
  requiredFrequencies: [500, 1000, 2000, 4000, 6000],
  allowMinorSingleFrequencyDeviation: true,
  minorDeviationMaxDb: 30,
  minorDeviationMaxCount: 1,
  inputStepDb: 5,
};
